var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnnotations = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 15.022V7.058c0-.528-.21-1.035-.586-1.408A2 2 0 0 0 18 5.067H6c-.53 0-1.04.21-1.414.583C4.21 6.023 4 6.53 4 7.058v7.964c0 .528.21 1.035.586 1.408.375.373.884.583 1.414.583h1L10 20l3-2.987h5c.53 0 1.04-.21 1.414-.583.375-.373.586-.88.586-1.408M7 9.05a1 1 0 0 1 1-.996h8a1 1 0 0 1 .707.292.993.993 0 0 1-.707 1.7H8a1 1 0 0 1-.707-.292A1 1 0 0 1 7 9.049Zm1 2.987a.993.993 0 1 0 0 1.991h3a1 1 0 0 0 .707-.292.994.994 0 0 0-.707-1.7z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnnotations);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/annotations.da91bf6e.svg";